import React from 'react'

export const PacienteAseguradoras = () => {
  return (
    <div>PacienteAseguradoras</div>
  )
}
